import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const DnDContext = createContext(null);

export function DnDProvider({ children }) {
  const [node, setNode] = useState(null);

  const value = useMemo(() => ({ node, setNode }), [node]);

  return <DnDContext.Provider value={value}>{children}</DnDContext.Provider>;
}

DnDProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useDnD = () => {
  const context = useContext(DnDContext);
  if (!context) {
    throw new Error('useDnD must be used within a DnDProvider');
  }
  return context;
};
